'use strict';

var $ = require('jquery');
var Animation = require('../lib/Animation.js');
var AnimationEasing = require('../lib/AnimationEasing.js');
var Range = require('../lib/Range.js');

function init() {
	var $masthead = $('.masthead');
	if ($masthead.length === 0)
		return;
	
	function setup(manager) {
		var $overlay = $masthead.children('.masthead__overlay');
		var $image = $masthead.children('.masthead__image');
		var $mastheadContent = $masthead.children('.intro');
		
		if ($mastheadContent.length === 0)
			return;
	
		var headerBottom = $masthead.outerHeight();
		var start = 0;
		var end = headerBottom;
		
		// Content
		var contentRange = new Range(0, -130, AnimationEasing.linear);
		manager.addArea(new Animation.Area('masthead content', start, end, 1,
				[
				 	new Animation.CSSProperty($mastheadContent, 'opacity', new Range(1, 0.1, AnimationEasing.linear)),
				 	new Animation.CSSProperty($mastheadContent, 'transform', function(percentage, area) {
				 		return 'translateY(' + contentRange.valueAt(percentage) + 'px)';
					})
				 ]));
		
		// Overlay
		manager.addArea(new Animation.Area('masthead overlay', start, end, 1,
				[new Animation.CSSProperty($overlay, 'opacity', new Range(0, 1, AnimationEasing.linear))]));
		
		// Image
		var imageRange = new Range(0, 90, AnimationEasing.linear);
		manager.addArea(new Animation.Area('masthead imge', start, end, 1,
				[new Animation.CSSProperty($image, 'transform', function(percentage, area) {
					return 'translateY(' + imageRange.valueAt(percentage) + 'px)';
				})]
		));
	}
	
	var manager = Animation.Manager.getInstance('scroll');
	manager.addSetup(setup);
}

module.exports = {
	init : init
};
